import styled from 'styled-components'

import Flex from 'Components/Flex'
import { NoMarginRow } from 'Components/EnhacedFlexboxGrid'
import { Col } from 'react-styled-flexboxgrid-tmp'

import {
  BREAK_POINT_MD,
} from '@CSSVars/variables'


export const _ChartsRow = styled(NoMarginRow)`
  margin: 8px 0;
`

export const _Col = styled(Col)`
  margin-bottom: 16px;
  @media screen and (min-width: ${BREAK_POINT_MD}) {
    max-width: 20%;
    flex-basis: 20%;
    margin-bottom: 0;
  }
`

export const _ChartBlock = styled(Flex)`
`

